'use strict';

var tealium = require('../tealium');
var socialSigninTrackingCookieName = 'socialSigninTracking';
var socialSigninCookieName = 'socialSignin';
var socialSigninContextStorageKey = 'socialSigninContext';

function applySocialSigninContextToUtag(payload) {
	var analyticsData = window.utag_data;
	var context;

	if (!analyticsData || !payload) {
		return;
	}

	context = {
		sign_in_mall: payload.sign_in_mall,
		sign_in_brand: payload.sign_in_brand,
		sign_in_vendor: payload.sign_in_vendor,
		fb_login_id: payload.fb_login_id || ''
	};

	analyticsData.sign_in_mall = context.sign_in_mall;
	analyticsData.sign_in_brand = context.sign_in_brand;
	analyticsData.sign_in_vendor = context.sign_in_vendor;
	if (context.fb_login_id) {
		analyticsData.fb_login_id = context.fb_login_id;
	}

	try {
		window.sessionStorage.setItem(socialSigninContextStorageKey, JSON.stringify(context));
	} catch (e) {
		// No-op when sessionStorage is unavailable.
	}
}

function hydrateSocialSigninContextFromSession() {
	var analyticsData = window.utag_data;
	var storedContext;

	if (!analyticsData || analyticsData.sign_in_vendor) {
		return;
	}

	try {
		storedContext = window.sessionStorage.getItem(socialSigninContextStorageKey);
		if (!storedContext) {
			return;
		}
		storedContext = JSON.parse(storedContext);
		analyticsData.sign_in_mall = storedContext.sign_in_mall || analyticsData.sign_in_mall;
		analyticsData.sign_in_brand = storedContext.sign_in_brand || analyticsData.sign_in_brand;
		analyticsData.sign_in_vendor = storedContext.sign_in_vendor || analyticsData.sign_in_vendor;
		if (storedContext.fb_login_id) {
			analyticsData.fb_login_id = storedContext.fb_login_id;
		}
	} catch (e) {
		// No-op when sessionStorage is unavailable or malformed.
	}
}

function getSocialSigninTracking() {
	var cookieValue = MERCH_UTILS.getCookie(socialSigninTrackingCookieName);
	var legacyCookieValue;
	var payload;

	if (cookieValue && cookieValue !== 'false') {
		try {
			payload = JSON.parse(decodeURIComponent(cookieValue));
			if (payload && payload.successPending) {
				return {
					payload: payload,
					cookieName: socialSigninTrackingCookieName
				};
			}
		} catch (e) {
			// Fall back to the existing social sign-in cookie.
		}
	}

	legacyCookieValue = MERCH_UTILS.getCookie(socialSigninCookieName);
	if (!legacyCookieValue || legacyCookieValue === 'false') {
		return null;
	}

	payload = {
		vendor: legacyCookieValue === 'AppleWebSignIn' ? 'Apple' : legacyCookieValue,
		successPending: true
	};
	if (legacyCookieValue !== 'Google' && legacyCookieValue !== 'AppleWebSignIn') {
		payload.vendor = 'Facebook';
		payload.facebookLoginId = legacyCookieValue;
	}

	return {
		payload: payload,
		cookieName: socialSigninCookieName
	};
}

function addCurrentStepContext(payload) {
	var currentStepObject = getCurrentStepObject();

	if (!currentStepObject) {
		return;
	}

	if (currentStepObject.page_name) {
		payload.page_name = currentStepObject.page_name;
	}
	if (currentStepObject.step_name) {
		payload.step_name = currentStepObject.step_name;
	}
	if (currentStepObject.skip_steps) {
		payload.skip_steps = currentStepObject.skip_steps;
	}
}

var checkout = {
    init: function() {
		$(document).ready(function(){
		hydrateSocialSigninContextFromSession();
		var socialSigninState = getSocialSigninTracking();
		var socialSigninTracking = socialSigninState && socialSigninState.payload;
		var analyticsData = window.utag_data;
		if (socialSigninTracking && socialSigninTracking.successPending && analyticsData) {
			var obj = {
				event_name: 'social_sign_in',
				sign_in_mall: analyticsData.shopping_mall,
				sign_in_brand: String(analyticsData.current_brand || '').toUpperCase(),
				sign_in_vendor: socialSigninTracking.vendor
			};

			if (socialSigninTracking.vendor === 'Facebook' && socialSigninTracking.facebookLoginId) {
				obj.fb_login_id = socialSigninTracking.facebookLoginId;
			}

			addCurrentStepContext(obj);

			tealium.triggerEvent(obj);
			// Always clear legacy fallback after success to avoid replay on later pages.
			MERCH_UTILS.setCookie(socialSigninCookieName, false, -1);

			// Keep a short-lived consumed marker so fallback lookup cannot replay even if
			// the bridge rehydrates this cookie before server session is cleared.
			MERCH_UTILS.setCookie(socialSigninTrackingCookieName, encodeURIComponent(JSON.stringify({ successPending: false })));

			applySocialSigninContextToUtag(obj);
		}
		});
 		$( document ).ajaxSuccess(function( event, xhr, settings ) {
  			if ( settings.url.indexOf(Urls.addCoupon) > -1  ) {
        		var vars = [], hash,couponResponse = '';
        		var couponCode = '';
        		var hashes = settings.url.split('?')[1].split('&');
        		for(var i = 0; i < hashes.length; i++)
        		{
         		 	hash = hashes[i].split('=');
          			vars.push(hash[0]);
          			vars[hash[0]] = hash[1];
        		}  			
    			var response = $.parseHTML(xhr.responseText);
    			if( vars.length != 0 && vars.couponCode != null ){
    				couponCode = vars.couponCode;
    			}
    			var code = $(response).find('.error-messages .error').data('code'); 
    			if( $(response).filter('.error-messages').find('.coupon-code-error').length > 0 ){
    				couponResponse = $(response).filter('.error-messages').find('.coupon-code-error').text().trim();
    			}
    			if(couponResponse == '' &&  $(response).filter('.error-messages').find('.applied-coupon-code').length > 0){
    				couponResponse = $(response).filter('.error-messages').find('.applied-coupon-code').text().trim();
    			}
    			var obj = {
		    		event_name : "coupon_code",
		    		coupon_code : couponCode,
		    		coupon_code_response : couponResponse
  				}
  				tealium.triggerEvent(obj);
  			}
  			if($('input[name="plccRebuttalVal"]').length > 0 && $('input[name="plccRebuttalVal"]').val() == 'true'){
				var obj = {
		    		event_name : "plc_offer_rebuttal",
					event_location_plc : ["plcc_offer_rebuttal"]
	        	}
	        	tealium.triggerEvent(obj);
				$('input[name="plccRebuttalVal"]').val("false");
	 		}
  			if ( settings.url.indexOf(Urls.applyGiftCard) > -1  ) {
  				var response = $.parseJSON(xhr.responseText).giftCertificate.success;
  				var giftCardResponse = '';
  				if( response == false ){
  					giftCardResponse = $.parseJSON(xhr.responseText).giftCertificate.responseMessage;
  				}
  				var obj = {
		    		event_name : "apply_gift_card",
		    		apply_gift_card_response : giftCardResponse
	        	}
  				tealium.triggerEvent(obj);
  			}
  			if ( settings.url.indexOf(Urls.redeemADSCert) > -1  ) {
  				var response = $.parseJSON(xhr.responseText).message;
  				var obj = {
		    		event_name : "reward_certificate",
		    		apply_reward_certificate_response : response
  				}
  				tealium.triggerEvent(obj);
  			}
		});

    	var plccZipCodeErrorObj={};
    	if(utag_data.plcc_payment_error) {
    		plccZipCodeErrorObj.event_name="plcc_payment_error";
    		plccZipCodeErrorObj.error_response = utag_data.plcc_payment_error;
    		tealium.triggerEvent(plccZipCodeErrorObj);
    	}
    	
    	
    }
};

exports.init = checkout.init;
